import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useInterval } from 'react-use';
const useIntervalTimer = (t0, t1, t2) => {
  const $ = _c(3);
  const callback = t0 === undefined ? _temp : t0;
  const delay = t1 === undefined ? 1000 : t1;
  const isTimerRunningInitial = t2 === undefined ? false : t2;
  const [isTimerRunning, setIsTimerRunning] = useState(isTimerRunningInitial);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsTimerRunning(true);
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const startTimer = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsTimerRunning(false);
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const stopTimer = t4;
  useInterval(callback, isTimerRunning ? delay : null);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      startTimer,
      stopTimer
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  return t5;
};
export default useIntervalTimer;
function _temp() {}